module.exports = __webpack_public_path__ + "img/home.7e3864d7.svg";